export const ElecRates = {
  Standard: "standard",
  Day: "day",
  Night: "night",
  EvPeak: "SO EV Peak",
  EvOffPeak: "SO EV Off-Peak"
}

export const TariffType = {
  Standard: "Standard",
  EV: "EV",
  Green: "Green"
}

export const RateType = {
  Fixed: "Fixed",
  Variable: "Variable"
}

export const ElecProductType = {
  Standard: "Standard",
  Eco7: "Eco7",
  TOU: "TOU"
}

export const SO_GREEN_TRACKER_TARIFF_CODE = "STRG"
